module.exports = __webpack_public_path__ + "media/img/uploads/solutions-tall-thumb-02-ad712d21636e8972e20af0a2e0ac61f5.jpg";